<template>
    <div class="block-content">
      <p v-if="!isConnectedToScanner" class="mt-5" style="position:absolute; bottom:0; right:0; color:red;">
        <i @click="openBarcodeScannerModal()" class="fa fa-plus-circle fa-3x text-muted fa-border" style="margin-left:10px; margin-right:10px; border:2px solid red;"></i>
      </p>
      <p v-if="isConnectedToScanner" class="mt-5" style="position:absolute; bottom:0; right:0; color:red;">
        <i @click="disconnectFromBarcodeScanner()" class="fa fa-circle-plus fa-3x text-muted fa-border" style="margin-left:10px; margin-right:10px; border:2px solid Green;"  ></i>
      </p>
       <barcode-scanner-detail-modal v-if="showBarcodeScannerModal" @close="showBarcodeScannerModal = null, isConnectedToBarcodeScanner()"></barcode-scanner-detail-modal>
    </div>
</template>

<script>
import BarcodeScannerDetailModal from './BarcodeScannerDetailModal.vue'
import Socket from './socket'

export default {
  components: {
    BarcodeScannerDetailModal
  },
  data () {
    return {
      showBarcodeScannerModal: null,
      isConnectedToScanner: false
    }
  },
  methods: {
    openBarcodeScannerModal () {
      this.showBarcodeScannerModal = true
    },
    isConnectedToBarcodeScanner () {
      if (Socket.connectedToBarcodeScanner) {
        this.isConnectedToScanner = true
      }
    },
    disconnectFromBarcodeScanner () {
      Socket.close()
      this.$swal('Hoera 😊', `Succesvol ontkoppeld met de barcode scanner.`, 'success')
      this.isConnectedToScanner = false
      Socket.connectedToBarcodeScanner = false
    }
  },
  created () {
    if (Socket.connectedToBarcodeScanner) {
      this.isConnectedToScanner = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// SelectBarcodeScannerWidget.vue?7f256da3